const LIFE_FORM_ERROR_MESSAGES = {
  FULL_NAME_REQUIRED: 'Please enter full name',
  GENDER_REQUIRED: 'Please select gender',
  DOB_REQUIRED: 'Please enter Date of Birth',
  MOBILE_REQUIRED: 'Please enter mobile number',
  INSURED_MEMBERS_REQUIRED: 'Please select at least one Member to be Insured',
  INSURANCE_TYPE: 'Please enter Insurance name',
}

const MOCK_QUICK_QUOTES = [
  {
    enquiryId: 'TROVITY_1245314562590498816',
    providerId: 'PROV_08',
    providerName: 'ICICI LOMBARD General Insurance Co. Ltd.',
    insuranceId: 'INS_15',
    insuranceName: 'Health Advantage',
    sumInsured: 10000000,
    correlationId: '03249319-a925-4558-b026-042ca9bdad13',
    basePremiumAmount: 2729.08,
    premiumAmount: 32200,
    providerImage:
      'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/provider/15.svg',
    claimSettled: '99.5%',
  },
  {
    enquiryId: 'TROVITY_1245314569913753600',
    providerId: 'PROV_05',
    providerName: 'Care Health Insurance Ltd',
    insuranceId: 'INS_08',
    insuranceName: 'Care Supreme',
    sumInsured: 10000000,
    basePremiumAmount: 2729.08,
    premiumAmount: 32200,
    providerImage:
      'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/provider/25.svg',
    claimSettled: '99%',
  },
  {
    enquiryId: 'TROVITY_1245314561256710144',
    providerId: 'PROV_02',
    providerName: 'Zuno General Insurance Limited',
    insuranceId: 'INS_05',
    insuranceName: 'Gold',
    sumInsured: 10000000,
    basePremiumAmount: 5879,
    premiumAmount: 69370.22,
    providerImage:
      'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/provider/10.svg',
    claimSettled: '99%',
  },
  {
    enquiryId: 'TROVITY1245314564226',
    providerId: 'PROV_04',
    providerName: 'Hdfc Ergo',
    insuranceId: 'INS_07',
    insuranceName: 'Optima Secure',
    sumInsured: 10000000,
    basePremiumAmount: 10263.56,
    premiumAmount: 121110,
    providerImage:
      'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/provider/14.svg',
    claimSettled: '99%',
  },
]

const SAMPLE_LIFE_QUICK_QUOTE_DETAILS = {
  enquiryId: 'TROVITY1245314564226',
  providerId: 'PROV_04',
  providerName: 'Hdfc Ergo',
  insuranceId: 'INS_07',
  insuranceName: 'Optima Secure',
  sumInsured: 10000000,
  basePremiumAmount: 10263.56,
  premiumAmount: 121110,
  providerImage:
    'https://paisaplan.s3.ap-south-1.amazonaws.com/dev/provider/14.svg',
  discountAmount: 2000,
}

const LIFE_COVER_VALUES = [
  {
    label: '25 Lacs',
    value: 2500000,
  },
  {
    label: '50 Lacs',
    value: 5000000,
  },
  {
    label: '75 Lacs',
    value: 7500000,
  },
  {
    label: '1 Crore',
    value: 10000000,
  },
  {
    label: '1.25 Crores',
    value: 12500000,
  },
  {
    label: '1.50 Crores',
    value: 15000000,
  },
  {
    label: '1.75 Crores',
    value: 17500000,
  },
  {
    label: '2 Crores',
    value: 20000000,
  },
  {
    label: '2.25 Crores',
    value: 22500000,
  },
  {
    label: '2.50 Crores',
    value: 25000000,
  },
  {
    label: '2.75 Crores',
    value: 27500000,
  },
  {
    label: '3 Crores',
    value: 30000000,
  },
  {
    label: '3.25 Crores',
    value: 32500000,
  },
  {
    label: '3.50 Crores',
    value: 35000000,
  },
  {
    label: '3.75 Crores',
    value: 37500000,
  },
  {
    label: '4 Crores',
    value: 40000000,
  },
  {
    label: '4.25 Crores',
    value: 42500000,
  },
  {
    label: '4.50 Crores',
    value: 45000000,
  },
  {
    label: '4.75 Crores',
    value: 47500000,
  },
  {
    label: '5 Crores',
    value: 50000000,
  },
]

export {
  LIFE_FORM_ERROR_MESSAGES,
  SAMPLE_LIFE_QUICK_QUOTE_DETAILS,
  MOCK_QUICK_QUOTES,
  LIFE_COVER_VALUES,
}

export const INSURANCE_CONSTANTS = {
  LIFE: 'Life',
  HEALTH: 'Health',
}
